import './ActionableMembersTable.css';

import React from 'react';
import ActionableIcon from '../../../b2b-common/ActionableIcon';
import B2BTableInMemory from '../../../b2b-common/B2BTableInMemory';
import Banner from '../../../b2b-common/Banner';
import { generateClassName } from '../../../b2b-common/helpers';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const ActionableMembersTable = ({ bannerMsg = null, members, ActionIcon, actionLabel = null, onActionOnMember, className = null }) => {

    const { t } = useB2BTranslation('b2b-logbook');

    const headers = [
        { label: t('Member'), align: 'left' },
        { label: t('Mail'), align: 'left' },
        { label: t('Role'), align: 'left' },
        { label: '', align: 'center' },
    ];

    const handleIconActionOnMember = (userId) => {
        onActionOnMember && onActionOnMember(userId);
    }

    const rows = members.map((member) => ({
        id: member.userId,
        cells: [
            {
                content: `${member.user.firstName} ${member.user.lastName}`,
                align: 'left',
            },
            {
                content: member.user.email,
                align: 'left',
            },
            {
                content: member.roles.map(role => t(role.roleName)).join(', '),
                align: 'left',
            },
            {
                content: <ActionableIcon
                    id={member.userId} icon={ActionIcon}
                    confirm={false}
                    onClick={handleIconActionOnMember}
                    tooltip={actionLabel}
                />,
                align: 'center',
            },
        ],
    }));

    return (
        <div className={generateClassName('actionable-members-table', '-container', className)}>
            {bannerMsg && <Banner sectionTittle={bannerMsg} headingLevel='h4' underline={false} />}
            <B2BTableInMemory
                headers={headers}
                rows={rows}
                className={generateClassName('actionable-members-table', '', className)}
                numRows={5}
            />
        </div>
    );
}

export default ActionableMembersTable;